module.exports = __webpack_public_path__ + "static/media/PeggyS.ce79ed7e.jpg";